import { useQuery } from 'react-query';

import { useAuth } from 'modules/authentication/presentation/contexts';
import { makeFetchOpenContractCancellationUseCase } from 'modules/customer/domain/useCases';
import { customerQueries } from 'modules/customer/presentation/constants';
import { useRequestErrorHandler } from 'shared/presentation/hooks';

type TParams = {
  useDefaultErrorHandler?: boolean;
};

export default function useContractCancellationTracking({
  useDefaultErrorHandler = true,
}: TParams = {}) {
  const { handleError } = useRequestErrorHandler('customer');
  const auth = useAuth();

  const query = useQuery(
    customerQueries.contractCancellationTracking(auth.session?.id),
    () => makeFetchOpenContractCancellationUseCase().execute(),
    {
      onError: error => {
        if (useDefaultErrorHandler) {
          handleError(error);
        }
      },
      enabled: !!auth.session,
    },
  );

  return {
    loading: query.isLoading,
    tracking: query.data || null,
    error: query.error,
    refetch: query.refetch,
  };
}
